module.exports = __webpack_public_path__ + "img/consulta-ja-logo-old.5ab625e3.svg";